/*
 *  This has been generated using the Synergy STDev tool.
 *  Any modifications will be lost after the next build
 */
import * as st from './STApp'
import { componentApi, loadTranslations } from 'common'


export class STMemoGeneratorAPI {
  async GetMemoLookupItems(srcName : string) : Promise<Array<st.LookupItem>> {
    return await componentApi.call('st', 'st-memo-generator-btn', 'STMemoGeneratorAPI', 'GetMemoLookupItems', {
      srcName,
    });
  }
  async Generate(hint : string, identity : string, srcName : string, lookupCode : string, style : st.WritingStyle) : Promise<any> {
    return await componentApi.call('st', 'st-memo-generator-btn', 'STMemoGeneratorAPI', 'Generate', {
      hint,
      identity,
      srcName,
      lookupCode,
      style,
    });
  }
  async ReviseText(selectedText : string, fullText : string) : Promise<any> {
    return await componentApi.call('st', 'st-memo-generator-btn', 'STMemoGeneratorAPI', 'ReviseText', {
      selectedText,
      fullText,
    });
  }
  async GetWritingStyles() : Promise<any> {
    return await componentApi.call('st', 'st-memo-generator-btn', 'STMemoGeneratorAPI', 'GetWritingStyles', {
    });
  }
  async SaveWritingStyle(style : st.WritingStyle) : Promise<any> {
    return await componentApi.call('st', 'st-memo-generator-btn', 'STMemoGeneratorAPI', 'SaveWritingStyle', {
      style,
    });
  }
}
export default new STMemoGeneratorAPI()
